import theme from "@/theme";
import { SVGProps } from "react";

interface ArrowsDiagramProps extends SVGProps<SVGSVGElement> {
  stroke?: string;
}

const ArrowsDiagram = ({
  stroke = theme.palette.custom.mainBlue,
  ...props
}: ArrowsDiagramProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M10 8 7 5 4 8M7 19V5M14 16l3 3 3-3M17 5v14"
    />
  </svg>
);

export default ArrowsDiagram;
